export enum CookieConsent {
  Mandatory = "Mandatory",
  NonEssentials = "NonEssentials",
}
